import { render, staticRenderFns } from "./EditMass.vue?vue&type=template&id=25be1e26&scoped=true"
import script from "./EditMass.vue?vue&type=script&lang=ts"
export * from "./EditMass.vue?vue&type=script&lang=ts"
import style0 from "./EditMass.vue?vue&type=style&index=0&id=25be1e26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25be1e26",
  null
  
)

export default component.exports